import type {
  ComponentLocalizationMap,
  LocalizationDerivationRegistry,
} from '@packages/domains/localization/dom/model';
import type {DomLocalizationState} from './state';

export function selectExternalizedLocalizationBindingsEnabled(
  state: DomLocalizationState
): boolean {
  return state.enableExternalizedBindings;
}

export function selectComponentLocalizations(
  state: DomLocalizationState
): ComponentLocalizationMap {
  return state.componentLocalizations;
}

export function selectStagedComponentLocalizations(
  state: DomLocalizationState
): ComponentLocalizationMap | undefined {
  return state.staged?.componentLocalizations;
}

export function selectLiveComponentLocalizations(
  state: DomLocalizationState
): ComponentLocalizationMap {
  return state.staged?.componentLocalizations ?? state.componentLocalizations;
}

export function selectLocalizationDerivations(
  state: DomLocalizationState
): LocalizationDerivationRegistry {
  return state.derivedKeys;
}
